export const BANNER_GET = 'bannerGet'
export const BANNER_DELETE = 'bannerDelete'
export const BANNER_CREATE = 'bannerCreate'